import { Badge, type BadgeProps } from '@mantine/core';
import {
  IconCheck,
  IconPlayerPause,
  IconPlayerPlay,
  IconHourglassLow,
} from '@tabler/icons-react';
import type { SessionStatus } from '@creativitas/shared';
import { SESSION_STATUS_LABELS } from '@creativitas/shared';

const STATUS_STYLE: Record<SessionStatus, { color: string; icon: typeof IconCheck }> = {
  waiting: { color: 'gray', icon: IconHourglassLow },
  active: { color: 'teal', icon: IconPlayerPlay },
  paused: { color: 'gold', icon: IconPlayerPause },
  completed: { color: 'sand', icon: IconCheck },
};

type SessionStatusBadgeProps = { status: SessionStatus } & Omit<BadgeProps, 'color' | 'children'>;

/** One badge for both spread and game sessions — the lifecycle is shared (§28). */
export function SessionStatusBadge({ status, ...props }: SessionStatusBadgeProps) {
  const style = STATUS_STYLE[status];
  const Icon = style.icon;

  return (
    <Badge
      color={style.color}
      variant={status === 'active' ? 'filled' : 'light'}
      leftSection={<Icon size={12} />}
      style={{ flexShrink: 0 }}
      {...props}
    >
      {SESSION_STATUS_LABELS[status]}
    </Badge>
  );
}
